(() => {
  angular
    .module('app')
    .component('hostInpatientGuaranteeLettersTopupAddonProcessingRequestDetailsComponent', {
      templateUrl: require('./requestDetails.component.html'),
      controller: TopUpAddOnProcessingDetailsComponentController,
      controllerAs: 'vm',
      bindings: {
        guaranteeLetterNumber: '<',
        serviceRequestId: '<',
        onEdit: '&',
        onSave: '&',
        newGuaranteeAmount: '=',
        currencyCode: '<',
      },
    });

  TopUpAddOnProcessingDetailsComponentController.$inject = [
    'abp.services.app.hostServiceRequest',
    'moment',
  ];

  function TopUpAddOnProcessingDetailsComponentController(hostServiceRequestSvc, moment) {
    const vm = this;

    vm.$onChanges = onChanges;
    vm.getAdmittingSpecialists = getAdmittingSpecialists;
    vm.lookupDoctor = lookupDoctor;
    vm.edit = edit;
    vm.save = save;
    vm.cancel = cancel;

    vm.updateNewGuaranteeAmount = updateNewGuaranteeAmount;

    vm.isEdit = false;
    vm.loading = 0;
    vm.request = null;
    vm.diagnosis = null;
    vm.documents = [];
    vm.filteredDoctors = [];

    vm.updateNewGuaranteeAmount = updateNewGuaranteeAmount;

    let preEditRequest = null;
    let preEditDiagnosis = null;
    let preEditDocuments = null;
    const limitSize = 100;
    let doctors = [];

    function onChanges(changes) {
      if (changes.serviceRequestId && changes.serviceRequestId.currentValue) {
        getRequestDetails(vm.serviceRequestId);
      }
    }

    function getRequestDetails(serviceRequestId) {
      vm.loading+=1;
      hostServiceRequestSvc
        .getTopupAddonRequestDetails({
          id: serviceRequestId,
        })
        .success((data) => {
          vm.request = {
            requestType: data.requestType,
            requestTime: data.requestTime,
            requestedBy: data.requestedBy,
            guaranteeLetterNumber: data.guaranteeLetterNumber,
            interimBillAmount: data.interimBillAmount,
            newGuaranteeAmount: data.newGuaranteeAmount,
            remarks: data.remarks,
            selectedDoctorIds: data.selectedDoctorIds,
          };

          vm.documents = _.map(data.supportingDocuments, (d) => ({
              externalObjectId: d.externalObjectId,
              url: d.url,
              name: d.name,
              uploader: `${d.uploader  } ${  moment(d.uploadedTime).format('L, LT')}`,
              applied: d.isApplied,
              isEditable: true,
              state: d.state,
            }));

          // Letter diagnosis (previous request diagnosis)

          vm.glDiagnosis = _.map(data.letterDiagnosis, (p) => ({
              code: p.code,
              description: p.description,
              displayDate: p.displayDiagnosisDate,
              date: p.diagnosisDate,
            }));

          // Current request diagnosis

        vm.diagnosis = {
          selected: _.map(data.provisionalDiagnosis, (p) => ({
              code: p.code,
              description: p.description,
              displayDate: p.displayDiagnosisDate,
              date: p.diagnosisDate
            })),
          icd: _.map(data.diseaseClassifications, (d) => ({
              id: d.id,
              code: d.code,
              description: `(${  d.code  }) ${  d.description}`,
              parentDescription: `(${ d.parentCode }) ${ d.parentDescription}`,
            }))
        };

        doctors = _.map(data.availableDoctors, (d) => ({
            id: d.id,
            name: d.name
          }));
      }).finally(() => {
        vm.loading -= 1
      });
    }

    function getAdmittingSpecialists() {
      if (vm.request && vm.request.selectedDoctorIds) {
        const selectedDoctorsName = _.map(vm.request.selectedDoctorIds, (i) => {
          const selectedDoctor = _.find(doctors, (d) => d.id === i);
          return selectedDoctor.name;
        });

        return selectedDoctorsName.join(', ');
      }
      return null;
    }

    function edit() {
      backupInitialStates();
      vm.isEdit = true;
      vm.onEdit({ isEdit: true });
    }

    function save() {
      if (App.isFormValid(vm.requestDetailsForm)) {
        vm.loading+=1;

        vm.request.id = vm.serviceRequestId;
        vm.request.estimatedCost = App.roundAmount(vm.request.estimatedCost);
        vm.request.newGuaranteeAmount = App.roundAmount(vm.request.newGuaranteeAmount);

        let provisionalDiagnosis = [];
        if (vm.diagnosis) {
          tidyDiagnosis();
          provisionalDiagnosis = _.map(vm.diagnosis.selected, (s) => 
            // Free-text entry has null diagnosis code.

             ({
              code: _.isNumber(s.code) ? null : s.code,
              description: s.description,
              diagnosisDate: s.date,
            })
          );
        }

        let supportingDocuments = [];
        if (vm.documents) {
          supportingDocuments = _.map(vm.documents, (d) => ({
              externalObjectId: d.externalObjectId,
              isApplied: d.applied,
            }));
        }

        const input = $.extend(
          {},
          vm.request,
          { provisionalDiagnosis },
          { supportingDocuments }
        );

        hostServiceRequestSvc
          .updateTopupAddonRequestDetails(input)
          .success(() => {
            abp.notify.info(App.localize('SuccessfullySaved'));
            getRequestDetails(vm.serviceRequestId);
            vm.isEdit = false;
            vm.onEdit({ isEdit: false });
            vm.onSave();
          })
          .finally(() => {
            vm.loading-=1;
          });
      }
    }

    function cancel() {
      restoreInitialStates();
      vm.isEdit = false;
      vm.onEdit({ isEdit: false });
    }

    function backupInitialStates() {
      preEditRequest = angular.copy(vm.request);
      preEditDiagnosis = angular.copy(vm.diagnosis);
      preEditDocuments = angular.copy(vm.documents);
    }

    function restoreInitialStates() {
      vm.request = preEditRequest;
      vm.diagnosis = preEditDiagnosis;
      vm.documents = preEditDocuments;
    }

    function lookupDoctor(filter) {
      const keyword = _.trim(filter || '');
      if (keyword) {
        const filteredDoctors = [];

        const regexes = _.chain(keyword.split(' '))
          .map((k) => _.trim(k.toUpperCase()))
          .filter((k) => k)
          .uniq()
          .map((k) => {
            _.escapeRegExp(k);
            return {
              token: k,
              len: k.length,
              pattern: new RegExp(`\\b${  k}`, 'i'),
            };
          })
          .value();

        _.forEach(doctors, (doctor) => {
          let score = 0;
          _.forEach(regexes, (r) => {
            if (r.pattern.test(doctor.name)) {
              score -= r.len;
            }
          });

          if (score) {
            filteredDoctors.push({
              score,
              item: doctor,
            });
          }
        });

        vm.filteredDoctors = _.chain(filteredDoctors)
          .sortBy(['score'])
          .take(30)
          .map((k) => k.item)
          .uniqBy((s) => s.id)
          .value();
      } else {
        vm.filteredDoctors = _.take(doctors, limitSize);
      }
    }

    function tidyDiagnosis() {
      vm.diagnosis.selected = _.filter(vm.diagnosis.selected, (item) => item.code !== undefined);
    }

    function updateNewGuaranteeAmount() {
      if (vm.request.newGuaranteeAmount) vm.newGuaranteeAmount = vm.request.newGuaranteeAmount;
      else vm.newGuaranteeAmount = 0;
    };
  }
  
})();
